.indicator {
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
	padding: 0rem 0.75rem;
	background: transparent;
	border: none;
	min-width: 200px;
	transition: all 0.2s ease;
}

.clickable {
	cursor: pointer;

	&:hover {
		.percentage {
			color: #7fb02f;
		}
	}
}

.content {
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
}

.label {
	font-size: 0.7rem;
	font-weight: 500;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.025em;
}

.percentage {
	font-size: 1.25rem;
	font-weight: 700;
	color: #111827;
	line-height: 1;
}

.progressBar {
	width: 100%;
	height: 6px;
	background: #e5e7eb;
	border-radius: 9999px;
	overflow: hidden;
}

.progressFill {
	height: 100%;
	border-radius: 9999px;
	transition: width 0.3s ease;
}

/* Variants */
.primary {
	.progressFill {
		background: linear-gradient(to right, #7fb02f, #8bc234);
	}
}

.info {
	.progressFill {
		background: linear-gradient(to right, #3b82f6, #60a5fa);
	}
}

.warning {
	.progressFill {
		background: linear-gradient(to right, #d77200, #f59e0b);
	}
}

.success {
	.progressFill {
		background: linear-gradient(to right, #22c55e, #4ade80);
	}
}

.sm {
	min-width: 120px;
	padding: 0.375rem 0.625rem;
	gap: 0.25rem;

	.label {
		font-size: 0.65rem;
	}

	.percentage {
		font-size: 1rem;
	}

	.progressBar {
		height: 3px;
	}
}

.md {
	/* Default styles already defined */
}

.lg {
	min-width: 180px;
	padding: 0.625rem 0.875rem;
	gap: 0.5rem;

	.label {
		font-size: 0.75rem;
	}

	.percentage {
		font-size: 1.5rem;
	}

	.progressBar {
		height: 5px;
	}
}

@media (max-width: 640px) {
	.indicator {
		min-width: 100px;
	}
}
